import {useQuery} from 'react-query';
import {mahsulCategories} from 'services/products/mahsulCategories';

const useGetmahsulCategories = () => {
  const {data: categorys, isLoading} = useQuery(
    ['mahsulCategories'],
    mahsulCategories,
  );
  return {categorys, isLoading};
};
export default useGetmahsulCategories;
